import { Component } from '@angular/core';
import { SearchBarComponent } from '../../_shared/_components/search/search-bar.component';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-product-not-found',
    templateUrl: './product-not-found.component.html',
    styleUrls: ['./product-not-found.component.scss'],
    imports: [SearchBarComponent, RouterLink, MatIcon]
})
export class ProductNotFoundComponent {
}
